import {
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BotAvatar from "./BotAvatar";
import { fonts } from "fonts";
import SmartToyIcon from "@mui/icons-material/SmartToy";

export default function ToolSelectorMenu({
  onToolSelected = (tool) => {},
  processing = false,
}) {
  const botState = useSelector((state) => state.bot);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  if (botState.loading) return null;

  const tools = botState.bots.filter((bot) => bot.isTool);

  if (tools.length === 0) return null;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectBot = (bot) => {
    onToolSelected(bot);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        {processing ? (
          <CircularProgress size={24} color="secondary" />
        ) : (
          <SmartToyIcon />
        )}
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {tools.map((bot) => (
          <MenuItem
            key={bot.id}
            selected={botState.current === bot.id}
            onClick={() => handleSelectBot(bot)}
          >
            <Stack direction="row" spacing={1}>
              <BotAvatar
                botId={bot.id}
                sx={{ width: "24px", height: "24px" }}
              />
              <Typography fontFamily={fonts.geist}>{bot.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
